module.exports = __webpack_public_path__ + "static/media/email.91a43dda.png";